// Filter configurations for different entity types

export const loadFilterConfig = {
  sections: [
    {
      title: 'Dates',
      rows: [
        {
          columns: 3,
          fields: [
            {
              key: 'pickupDate',
              label: 'Pick Up',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'deliveryDate',
              label: 'Delivery',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'creationDate',
              label: 'Creation',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'assignedDate',
              label: 'Assigned Date',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'deadline',
              label: 'Deadline',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        }
      ]
    },
    {
      title: 'Order',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'orderId',
              label: 'Order ID',
              type: 'text',
              placeholder: 'Text'
            },
            {
              key: 'customerOrderReference',
              label: 'Customer Order/Reference',
              type: 'text',
              placeholder: 'Text'
            }
          ]
        }
      ]
    },
    {
      title: 'Company Info',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'customerCompany',
              label: 'Customer Company Name',
              type: 'select',
              searchable: true,
              placeholder: 'Text',
              options: []
            },
            {
              key: 'carrierCompany',
              label: 'Carrier Company Name',
              type: 'select',
              searchable: true,
              placeholder: 'Text',
              options: []
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'carrierMC',
              label: 'Carrier MC#',
              type: 'select',
              searchable: true,
              placeholder: 'Text',
              options: []
            },
            {
              key: 'carrierTypes',
              label: 'Carrier Type(s)',
              type: 'multiSelectPills',
              options: []
            }
          ]
        }
      ]
    },
    {
      title: 'Load Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'status',
              label: '',
              type: 'segmentedSingle',
              options: [
                { value: 'Listed', label: 'Listed' },
                { value: 'Dispatched', label: 'Dispatched' },
                { value: 'Picked Up', label: 'Picked Up' },
                { value: 'Delivered', label: 'Delivered' },
                { value: 'On Hold', label: 'On Hold' },
                { value: 'Cancelled', label: 'Cancelled' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Shipment Type',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'shipmentType',
              label: '',
              type: 'segmentedSingle',
              options: [
                { value: '', label: 'All' },
                { value: 'freight', label: 'Freight' },
                { value: 'vehicle', label: 'Vehicle' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Payment & TONU',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'paymentMethod',
              label: 'Payment Method',
              type: 'select',
              placeholder: 'Any',
              options: [
                { value: '', label: 'Any' },
                { value: 'ACH', label: 'ACH' },
                { value: 'Wire', label: 'Wire' },
                { value: 'Check', label: 'Check' },
                { value: 'Credit Card', label: 'Credit Card' },
                { value: 'Zelle', label: 'Zelle' },
                { value: 'Factoring', label: 'Factoring' },
                { value: 'Other', label: 'Other' }
              ]
            },
            {
              key: 'paymentTerms',
              label: 'Payment Terms',
              type: 'text',
              placeholder: 'Text'
            }
          ]
        },
        {
          columns: 1,
          fields: [
            {
              key: 'hasTonu',
              label: 'Has TONU',
              type: 'segmentedSingle',
              options: [
                { value: '', label: 'Any' },
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Internal Assignments',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'agentEmails',
              label: "Agent’s Emails",
              type: 'multiSelectPills',
              options: []
            },
            {
              key: 'agentNames',
              label: "Agent’s Names",
              type: 'multiSelectPills',
              options: []
            }
          ]
        }
      ]
    },
    {
      title: 'Accounts Payable',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'accountsPayableStatus',
              label: '',
              type: 'multiStatusPills',
              options: [
                { value: 'Invoiced', label: 'Invoiced' },
                { value: 'Paid', label: 'Paid' },
                { value: 'On Hold', label: 'On Hold' },
                { value: 'Withheld', label: 'Withheld' },
                { value: 'Charges Applied', label: 'Charges Applied' }
              ]
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'accountsPayableInvoicedDate',
              label: 'Invoiced Date',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'accountsPayablePaidDate',
              label: 'Paid Date',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        }
      ]
    },
    {
      title: 'Accounts Receivable',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'accountsReceivableStatus',
              label: '',
              type: 'multiStatusPills',
              options: [
                { value: 'Invoiced', label: 'Invoiced' },
                { value: 'Paid', label: 'Paid' },
                { value: 'On Hold', label: 'On Hold' },
                { value: 'Withheld', label: 'Withheld' },
                { value: 'Charges Applied', label: 'Charges Applied' }
              ]
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'accountsReceivableInvoicedDate',
              label: 'Invoiced Date',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'accountsReceivablePaidDate',
              label: 'Paid Date',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        }
      ]
    },
    {
      title: 'Customer Payment Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'customerPaymentStatus',
              label: '',
              type: 'checkboxGroup',
              groups: [
                {
                  title: 'Carrier Charges',
                  options: [
                    { value: 'carrierTonuPaid', label: 'TONU Paid' },
                    { value: 'carrierDetentionPaid', label: 'Detention Paid' },
                    { value: 'carrierLayoverPaid', label: 'Layover Paid' }
                  ]
                },
                {
                  title: 'Customer Charges',
                  options: [
                    { value: 'customerTonuPaid', label: 'TONU Paid' },
                    { value: 'customerDetentionPaid', label: 'Detention Paid' },
                    { value: 'customerLayoverPaid', label: 'Layover Paid' }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export const userFilterConfig = {
  sections: [
    {
      title: 'User Information',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'firstName',
              label: 'First Name',
              type: 'text',
              placeholder: 'Text'
            },
            {
              key: 'lastName',
              label: 'Last Name',
              type: 'text',
              placeholder: 'Text'
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'email',
              label: 'Email',
              type: 'text',
              placeholder: 'Email'
            },
            {
              key: 'companyName',
              label: 'Company Name',
              type: 'text',
              placeholder: 'Text'
            }
          ]
        }
      ]
    },
    {
      title: 'Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'status',
              label: '',
              type: 'segmentedSingle',
              options: [
                { value: 'active', label: 'Active' },
                { value: 'suspended', label: 'Suspended' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Role',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'role',
              label: '',
              type: 'multiStatusPills',
              options: [
                { value: 'admin', label: 'Admin' },
                { value: 'manager', label: 'Manager' },
                { value: 'accountingManager', label: 'Accounting Manager' },
                { value: 'accountingIn', label: 'Accounting In' },
                { value: 'accountingOut', label: 'Accounting Out' },
                { value: 'freightBroker', label: 'Freight Broker' },
                { value: 'dispatcher', label: 'Dispatcher' },
                { value: 'Pre-dispatcher', label: 'Pre-dispatcher' },
                { value: 'partner', label: 'Partner' },
                { value: 'salesAgent', label: 'Sales Agent' },
                { value: 'bidAgent', label: 'Bid Agent' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Date',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'createdDate',
              label: 'Created Date',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        }
      ]
    }
  ]
};

export const customerFilterConfig = {
  sections: [
    {
      title: 'Company Information',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'companyName',
              label: 'Company Name',
              type: 'text',
              placeholder: 'Text'
            },
            {
              key: 'email',
              label: 'Email',
              type: 'text',
              placeholder: 'Email'
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'phoneNumber',
              label: 'Phone Number',
              type: 'text',
              placeholder: 'Phone'
            }
          ]
        }
      ]
    },
    {
      title: 'Location',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'city',
              label: 'City',
              type: 'text',
              placeholder: 'City'
            },
            {
              key: 'state',
              label: 'State',
              type: 'text',
              placeholder: 'State'
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'address.address',
              label: 'Street Address',
              type: 'text',
              placeholder: 'Street Address'
            },
            {
              key: 'zipCode',
              label: 'Zip Code',
              type: 'text',
              placeholder: 'Zip Code'
            }
          ]
        }
      ]
    },
    {
      title: 'Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'status',
              label: '',
              type: 'segmentedSingle',
              options: [
                { value: 'active', label: 'Active' },
                { value: 'suspended', label: 'Suspended' },
                { value: 'inactive', label: 'Inactive' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Type',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'type',
              label: '',
              type: 'segmentedSingle',
              options: [
                { value: 'platform', label: 'Platform' },
                { value: 'customer', label: 'Customer' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Payment Information',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'paymentMethod',
              label: 'Payment Method',
              type: 'select',
              options: [
                { value: 'ACH', label: 'ACH' },
                { value: 'ZELLE', label: 'Zelle' },
                { value: 'Net 30', label: 'Net 30' }
              ]
            },
            {
              key: 'paymentTerms',
              label: 'Payment Terms',
              type: 'text',
              placeholder: 'Text'
            }
          ]
        }
      ]
    },
    {
      title: 'Dates',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'createdAt',
              label: 'Created Date',
              type: 'dateRange',
              placeholder: 'Select date range'
            }
          ]
        }
      ]
    },
    {
      title: 'Related Loads',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'orderId',
              label: 'Load Order ID',
              type: 'text',
              placeholder: 'Search by Load Order ID'
            }
          ]
        }
      ]
    }
  ]
};

export const carrierFilterConfig = {
  sections: [
    {
      title: 'Company Information',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'name',
              label: 'Name',
              type: 'text',
              placeholder: 'Text'
            },
            {
              key: 'companyName',
              label: 'Company Name',
              type: 'text',
              placeholder: 'Text'
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'email',
              label: 'Email',
              type: 'text',
              placeholder: 'Email'
            },
            {
              key: 'phoneNumber',
              label: 'Phone Number',
              type: 'text',
              placeholder: 'Phone'
            }
          ]
        }
      ]
    },
    {
      title: 'Registration',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'mcNumber',
              label: 'MC#',
              type: 'text',
              placeholder: 'Number'
            },
            {
              key: 'dotNumber',
              label: 'DOT#',
              type: 'text',
              placeholder: 'Number'
            }
          ]
        }
      ]
    },
    {
      title: 'Location',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'city',
              label: 'City',
              type: 'text',
              placeholder: 'City'
            },
            {
              key: 'state',
              label: 'State',
              type: 'text',
              placeholder: 'State'
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'address.address',
              label: 'Street Address',
              type: 'text',
              placeholder: 'Street Address'
            },
            {
              key: 'zipCode',
              label: 'Zip Code',
              type: 'text',
              placeholder: 'Zip Code'
            }
          ]
        }
      ]
    },
    {
      title: 'Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'status',
              label: '',
              type: 'segmentedSingle',
              options: [
                { value: 'active', label: 'Active' },
                { value: 'suspended', label: 'Suspended' },
                { value: 'inactive', label: 'Inactive' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'People',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'people.type',
              label: 'People Type',
              type: 'segmentedSingle',
              options: [
                { value: 'driver', label: 'Driver' },
                { value: 'dispatcher', label: 'Dispatcher' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Equipment & Capabilities',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'equipmentType',
              label: 'Equipment Type',
              type: 'multiSelectPills',
              options: [
                { value: 'Auto Carrier', label: 'Auto Carrier' },
                { value: 'Car Hauler/Enclosed Trailer', label: 'Car Hauler/Enclosed Trailer' },
                { value: 'Pickups', label: 'Pickups' },
                { value: 'Semi Truck', label: 'Semi Truck' },
                { value: 'Dry Van', label: 'Dry Van' },
                { value: 'Reefer', label: 'Reefer' },
                { value: 'Box Truck', label: 'Box Truck' },
                { value: 'Flatbed', label: 'Flatbed' },
                { value: 'Step Deck', label: 'Step Deck' },
                { value: 'Hot Shot', label: 'Hot Shot' },
                { value: 'Conestoga', label: 'Conestoga' },
                { value: 'Curtain Van', label: 'Curtain Van' },
                { value: 'Sprinter Van', label: 'Sprinter Van' },
                { value: 'Heavy Haul', label: 'Heavy Haul' },
                { value: 'RGN', label: 'RGN' },
                { value: 'Extendable RGN', label: 'Extendable RGN' },
                { value: 'Lowboy', label: 'Lowboy' },
                { value: 'Tilt Bed', label: 'Tilt Bed' },
                { value: 'Landoll', label: 'Landoll' },
                { value: 'Power Only', label: 'Power Only' },
                { value: 'Tanker Endorsement', label: 'Tanker Endorsement' },
                { value: 'Hopper Bottom', label: 'Hopper Bottom' },
                { value: 'Perimeter', label: 'Perimeter' },
                { value: 'Flat Deck', label: 'Flat Deck' },
                { value: 'Dual Lane Transporter', label: 'Dual Lane Transporter' },
                { value: 'Super Dual Lane Transporter', label: 'Super Dual Lane Transporter' },
                { value: 'Drayage/Intermodal', label: 'Drayage/Intermodal' }
              ]
            },
            {
              key: 'size',
              label: 'Size',
              type: 'multiSelectPills',
              options: [
                { value: "16'", label: "16'" },
                { value: "24'", label: "24'" },
                { value: "26'", label: "26'" },
                { value: "40'", label: "40'" },
                { value: "48'", label: "48'" },
                { value: "53'", label: "53'" },
                { value: 'N/A', label: 'N/A' },
                { value: 'Other', label: 'Other' }
              ]
            }
          ]
        },
        {
          columns: 2,
          fields: [
            {
              key: 'capabilities',
              label: 'Capabilities',
              type: 'multiSelectPills',
              options: [
                { value: 'Lift Gate', label: 'Lift Gate' },
                { value: 'Winch', label: 'Winch' },
                { value: 'Team Drivers', label: 'Team Drivers' },
                { value: 'Driver Assistance', label: 'Driver Assistance' },
                { value: 'Residential pickup/delivery', label: 'Residential pickup/delivery' },
                { value: 'Inside pickup/delivery', label: 'Inside pickup/delivery' },
                { value: 'Appointment-based deliveries', label: 'Appointment-based deliveries' },
                { value: 'Cross-docking/transloading', label: 'Cross-docking/transloading' },
                { value: 'White-glove', label: 'White-glove' },
                { value: 'Final-mile', label: 'Final-mile' },
                { value: 'Blind Shipments', label: 'Blind Shipments' }
              ]
            },
            {
              key: 'certifications',
              label: 'Certifications',
              type: 'multiSelectPills',
              options: [
                { value: 'HAZMAT', label: 'HAZMAT' },
                { value: 'TWIC', label: 'TWIC' },
                { value: 'SmartWay Certified', label: 'SmartWay Certified' },
                { value: 'C-TPAT', label: 'C-TPAT' },
                { value: 'ISO Certified', label: 'ISO Certified' },
                { value: 'UIIA Member', label: 'UIIA Member' },
                { value: 'Bonded Carrier', label: 'Bonded Carrier' },
                { value: 'Minority-Owned', label: 'Minority-Owned' },
                { value: 'Women-Owned', label: 'Women-Owned' },
                { value: 'Veteran-Owned', label: 'Veteran-Owned' },
                { value: 'Disability-Owned', label: 'Disability-Owned' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Dates',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'createdAt',
              label: 'Created Date',
              type: 'dateRange',
              placeholder: 'Select date range'
            }
          ]
        }
      ]
    },
    {
      title: 'Related Loads',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'orderId',
              label: 'Load Order ID',
              type: 'text',
              placeholder: 'Search by Load Order ID'
            }
          ]
        }
      ]
    }
  ]
};

export const paymentPayableFilterConfig = {
  sections: [
    {
      title: 'Carrier Information',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'carrierCompany',
              label: 'Carrier Company Name',
              type: 'text',
              placeholder: 'Text'
            },
            {
              key: 'carrierMC',
              label: 'Carrier MC#',
              type: 'text',
              placeholder: 'Number'
            }
          ]
        }
      ]
    },
    {
      title: 'Payment Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'status',
              label: '',
              type: 'multiStatusPills',
              options: [
                { value: 'pending', label: 'Pending' },
                { value: 'invoiced', label: 'Invoiced' },
                { value: 'withheld', label: 'Withheld' },
                { value: 'canceled', label: 'Canceled' },
                { value: 'on Hold', label: 'On Hold' },
                { value: 'paid', label: 'Paid' },
                { value: 'partially paid', label: 'Partially Paid' },
                { value: 'pay today', label: 'Pay Today' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Payment Method',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'paymentMethod',
              label: 'Payment Method',
              type: 'select',
              options: [
                { value: 'ACH', label: 'ACH' },
                { value: 'Wire', label: 'Wire' },
                { value: 'Check', label: 'Check' },
                { value: 'Credit Card', label: 'Credit Card' },
                { value: 'Cash', label: 'Cash' },
                { value: 'Zelle', label: 'Zelle' },
                { value: 'Factoring', label: 'Factoring' },
                { value: 'Other', label: 'Other' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Dates',
      rows: [
        {
          columns: 3,
          fields: [
            {
              key: 'invoiceDate',
              label: 'Invoiced Date',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'dueDate',
              label: 'Due Date',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'paidDate',
              label: 'Paid Date',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        }
      ]
    }
  ]
};

export const paymentReceivableFilterConfig = {
  sections: [
    {
      title: 'Customer Information',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'customerCompany',
              label: 'Customer Company Name',
              type: 'text',
              placeholder: 'Text'
            },
            {
              key: 'customerEmail',
              label: 'Customer Email',
              type: 'text',
              placeholder: 'Email'
            }
          ]
        }
      ]
    },
    {
      title: 'Payment Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'status',
              label: '',
              type: 'multiStatusPills',
              options: [
                { value: 'pending', label: 'Pending' },
                { value: 'invoiced', label: 'Invoiced' },
                { value: 'withheld', label: 'Withheld' },
                { value: 'canceled', label: 'Canceled' },
                { value: 'on Hold', label: 'On Hold' },
                { value: 'received', label: 'Received' },
                { value: 'partially received', label: 'Partially Received' },
                { value: 'pay today', label: 'Pay Today' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Payment Method',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'paymentMethod',
              label: 'Payment Method',
              type: 'select',
              options: [
                { value: 'ACH', label: 'ACH' },
                { value: 'Wire', label: 'Wire' },
                { value: 'Check', label: 'Check' },
                { value: 'Credit Card', label: 'Credit Card' },
                { value: 'Cash', label: 'Cash' },
                { value: 'Zelle', label: 'Zelle' },
                { value: 'Other', label: 'Other' }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Dates',
      rows: [
        {
          columns: 3,
          fields: [
            {
              key: 'invoiceDate',
              label: 'Invoiced Date',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'dueDate',
              label: 'Due Date',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'receivedDate',
              label: 'Received Date',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        }
      ]
    }
  ]
};

export const getLoadHistoryFilterConfig = (users = []) => {
  const userOptions = users.map((u) => ({
    value: u._id || u.id,
    label: [u.firstName, u.lastName].filter(Boolean).join(' ') || u.email || u._id || ''
  }));
  return {
    sections: [
      {
        title: 'Load History',
        rows: [
          {
            columns: 2,
            fields: [
              {
                key: 'action',
                label: 'Action',
                type: 'select',
                placeholder: 'All actions',
                options: [
                  { value: '', label: 'All actions' },
                  { value: 'created', label: 'Created' },
                  { value: 'updated', label: 'Updated' },
                  { value: 'status_update', label: 'Status changed' },
                  { value: 'assign', label: 'Assigned' },
                  { value: 'delete', label: 'Deleted' }
                ]
              },
              {
                key: 'userId',
                label: 'User',
                type: 'select',
                placeholder: 'All users',
                options: [{ value: '', label: 'All users' }, ...userOptions]
              }
            ]
          },
          {
            columns: 2,
            fields: [
              {
                key: 'dateFrom',
                label: 'From date',
                type: 'date',
                placeholder: 'Date'
              },
              {
                key: 'dateTo',
                label: 'To date',
                type: 'date',
                placeholder: 'Date'
              }
            ]
          }
        ]
      }
    ]
  };
};

export const userStatisticFilterConfig = {
  sections: [
    {
      title: 'Scope',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'scopeType',
              label: 'Scope',
              type: 'segmentedSingle',
              options: [
                { value: 'global', label: 'Global' },
                { value: 'user', label: 'By User' },
                { value: 'customer', label: 'By Customer' },
                { value: 'carrier', label: 'By Carrier' }
              ],
              defaultValue: 'global'
            },
            {
              key: 'scopeId',
              label: 'ID (User / Customer / Carrier)',
              type: 'text',
              placeholder: '24-char ID when not Global',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Custom date range',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'dateFrom',
              label: 'From',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            },
            {
              key: 'dateTo',
              label: 'To',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'User Role',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'userRole',
              label: 'Filter by User Role',
              type: 'multiStatusPills',
              options: [
                { value: 'admin', label: 'Admin' },
                { value: 'manager', label: 'Manager' },
                { value: 'accountingManager', label: 'Accounting Manager' },
                { value: 'accountingIn', label: 'Accounting In' },
                { value: 'accountingOut', label: 'Accounting Out' },
                { value: 'freightBroker', label: 'Freight Broker' },
                { value: 'dispatcher', label: 'Dispatcher' },
                { value: 'Pre-dispatcher', label: 'Pre-dispatcher' },
                { value: 'partner', label: 'Partner' },
                { value: 'salesAgent', label: 'Sales Agent' },
                { value: 'bidAgent', label: 'Bid Agent' }
              ],
              defaultValue: []
            }
          ]
        }
      ]
    },
    {
      title: 'User Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'userStatus',
              label: 'Filter by User Status',
              type: 'multiStatusPills',
              options: [
                { value: 'active', label: 'Active' },
                { value: 'suspended', label: 'Suspended' }
              ],
              defaultValue: []
            }
          ]
        }
      ]
    }
  ]
};

export const loadsStatisticFilterConfig = {
  sections: [
    {
      title: 'Scope',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'scopeType',
              label: 'Scope',
              type: 'segmentedSingle',
              options: [
                { value: 'global', label: 'Global' },
                { value: 'user', label: 'By User' },
                { value: 'customer', label: 'By Customer' },
                { value: 'carrier', label: 'By Carrier' }
              ],
              defaultValue: 'global'
            },
            {
              key: 'scopeId',
              label: 'ID (User / Customer / Carrier)',
              type: 'text',
              placeholder: '24-char ID when not Global',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Custom date range',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'dateFrom',
              label: 'From',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            },
            {
              key: 'dateTo',
              label: 'To',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Load Statuses',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'loadStatus',
              label: 'Filter by Load Status',
              type: 'multiStatusPills',
              options: [
                { value: 'Listed', label: 'Listed' },
                { value: 'Dispatched', label: 'Dispatched' },
                { value: 'Picked up', label: 'Picked up' },
                { value: 'Delivered', label: 'Delivered' },
                { value: 'On Hold', label: 'On Hold' },
                { value: 'Cancelled', label: 'Cancelled' }
              ],
              defaultValue: []
            }
          ]
        }
      ]
    },
    {
      title: 'Shipment Type',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'shipmentType',
              label: 'Filter by Shipment Type',
              type: 'segmentedSingle',
              options: [
                { value: '', label: 'All' },
                { value: 'freight', label: 'Freight' },
                { value: 'vehicle', label: 'Vehicle' }
              ],
              defaultValue: ''
            }
          ]
        }
      ]
    }
  ]
};

export const paymentsStatisticFilterConfig = {
  sections: [
    {
      title: 'Scope',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'scopeType',
              label: 'Scope',
              type: 'segmentedSingle',
              options: [
                { value: 'global', label: 'Global' },
                { value: 'user', label: 'By User' },
                { value: 'customer', label: 'By Customer' },
                { value: 'carrier', label: 'By Carrier' }
              ],
              defaultValue: 'global'
            },
            {
              key: 'scopeId',
              label: 'ID (User / Customer / Carrier)',
              type: 'text',
              placeholder: '24-char ID when not Global',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Custom date range',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'dateFrom',
              label: 'From',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            },
            {
              key: 'dateTo',
              label: 'To',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Payment Type',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'paymentType',
              label: 'Filter by Payment Type',
              type: 'segmentedSingle',
              options: [
                { value: '', label: 'All' },
                { value: 'receivable', label: 'Receivable' },
                { value: 'payable', label: 'Payable' }
              ],
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Payment Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'paymentStatus',
              label: 'Filter by Payment Status',
              type: 'multiStatusPills',
              options: [
                { value: 'pending', label: 'Pending' },
                { value: 'invoiced', label: 'Invoiced' },
                { value: 'withheld', label: 'Withheld' },
                { value: 'canceled', label: 'Canceled' },
                { value: 'on Hold', label: 'On Hold' },
                { value: 'received', label: 'Received' },
                { value: 'paid', label: 'Paid' },
                { value: 'partially received', label: 'Partially Received' },
                { value: 'partially paid', label: 'Partially Paid' },
                { value: 'pay today', label: 'Pay Today' }
              ],
              defaultValue: []
            }
          ]
        }
      ]
    }
  ]
};

export const carrierStatisticFilterConfig = {
  sections: [
    {
      title: 'Custom date range',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'dateFrom',
              label: 'From',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            },
            {
              key: 'dateTo',
              label: 'To',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Carrier Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'carrierStatus',
              label: 'Filter by Carrier Status',
              type: 'multiStatusPills',
              options: [
                { value: 'active', label: 'Active' },
                { value: 'suspended', label: 'Suspended' },
                { value: 'inactive', label: 'Inactive' }
              ],
              defaultValue: []
            }
          ]
        }
      ]
    }
  ]
};

export const customerStatisticFilterConfig = {
  sections: [
    {
      title: 'Custom date range',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'dateFrom',
              label: 'From',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            },
            {
              key: 'dateTo',
              label: 'To',
              type: 'date',
              placeholder: 'Date',
              defaultValue: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Customer Status',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'customerStatus',
              label: 'Filter by Customer Status',
              type: 'multiStatusPills',
              options: [
                { value: 'active', label: 'Active' },
                { value: 'suspended', label: 'Suspended' },
                { value: 'inactive', label: 'Inactive' }
              ],
              defaultValue: []
            }
          ]
        }
      ]
    },
    {
      title: 'Customer Type',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'customerType',
              label: 'Filter by Customer Type',
              type: 'segmentedSingle',
              options: [
                { value: '', label: 'All' },
                { value: 'platform', label: 'Platform' },
                { value: 'customer', label: 'Customer' }
              ],
              defaultValue: ''
            }
          ]
        }
      ]
    }
  ]
};

export const statisticsFilterConfig = {
  sections: [
    {
      title: 'Scope',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'scopeType',
              label: 'Scope',
              type: 'segmentedSingle',
              options: [
                { value: 'global', label: 'Global' },
                { value: 'user', label: 'By User' },
                { value: 'customer', label: 'By Customer' },
                { value: 'carrier', label: 'By Carrier' }
              ]
            },
            {
              key: 'scopeId',
              label: 'ID (User / Customer / Carrier)',
              type: 'text',
              placeholder: '24-char ID when not Global'
            }
          ]
        }
      ]
    },
    {
      title: 'Custom date range',
      rows: [
        {
          columns: 2,
          fields: [
            {
              key: 'dateFrom',
              label: 'From',
              type: 'date',
              placeholder: 'Date'
            },
            {
              key: 'dateTo',
              label: 'To',
              type: 'date',
              placeholder: 'Date'
            }
          ]
        }
      ]
    },
    {
      title: 'Load statuses',
      rows: [
        {
          columns: 1,
          fields: [
            {
              key: 'statuses',
              label: 'Include only these statuses',
              type: 'multiStatusPills',
              options: [
                { value: 'Listed', label: 'Listed' },
                { value: 'Dispatched', label: 'Dispatched' },
                { value: 'Picked up', label: 'Picked up' },
                { value: 'Delivered', label: 'Delivered' },
                { value: 'On Hold', label: 'On Hold' },
                { value: 'Cancelled', label: 'Cancelled' }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export const getFilterConfig = (entityType) => {
  const configs = {
    loads: loadFilterConfig,
    users: userFilterConfig,
    customers: customerFilterConfig,
    carriers: carrierFilterConfig,
    paymentsPayable: paymentPayableFilterConfig,
    paymentsReceivable: paymentReceivableFilterConfig,
    loadHistory: getLoadHistoryFilterConfig(),
    statistics: statisticsFilterConfig,
    userStatistic: userStatisticFilterConfig,
    loadsStatistic: loadsStatisticFilterConfig,
    paymentsStatistic: paymentsStatisticFilterConfig,
    carrierStatistic: carrierStatisticFilterConfig,
    customerStatistic: customerStatisticFilterConfig
  };
  return configs[entityType] || null;
};
